import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { useMemo } from "react";
import { getItemUrl, isNotNull } from "sprout-lib";
import { sortLabels } from "@sprout/client-lib/dist/labels_next";
import useAlterLabelsForItems from "@sprout/client-components/dist/Dialog_next/LabelsDialog/graphql/mutations/useAlterLabelsForItems";
import { UrlDisplay } from "@sprout/client-components/dist/UrlDisplay";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import PostPageLabels from "../PostPageLabels";
import PostPageHeaderFocusWhenButton from "../PostPageHeaderFocusWhenButton";
import PostPageHeader from "../PostPageHeader";
import PostPageCard from "../PostPageCard";
import { usePostPage } from "../PostPageContext";
import { usePostPageEditor } from "../PostPageEditorContext";
import PostPageComments from "../PostPageComments";
import PostPagePageBanner from "../PostPagePageBanner";
import { usePostPageNoteEditor, PostPageNoteEditor } from "../PostPageEditors";
import PostPageTodos from "../PostPageTodos";
import PostPageAssignees from "../PostPageAssignees";
import PostPageHeaderStarredButton from "../PostPageHeaderStarredButton";
import { PostPagePost } from "../PostPagePost";
import usePostPageAssignAndLabelAction from "../usePostPageAssignAndLabelAction";
import PostPageWhenOrDeadline from "../PostPageWhenOrDeadline";
import usePostPageSharedGlobalHandlers from "../usePostPageSharedGlobalHandlers";
const PostPageCardsWrapper = styled("div")`
  > ${PostPageCard} + ${PostPageCard} {
    margin-top: 24px;
  }
`;
const PostPageEmbedNoteCard = styled(PostPageCard)`
  > * + * {
    margin-top: 24px;
  }
`;
const PostPageViewsPostMain = (props)=>{
    var ref1;
    const { post  } = props;
    const { parentTopic , note , breadcrumbsList , appliedLabels , rootTopicOrSelf , userPreferences , id , nodeId , url , linkLogo , linkImage , linkTitle , linkDescription , websiteName , commentCount , comments , assignments , when , whenReminder , deadline , currentUserHasStarred ,  } = post;
    const rootOwner = rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.owner;
    const rootURL = getItemUrl(rootTopicOrSelf, rootOwner);
    const allLabels = useMemo(()=>{
        return (rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.labels.nodes) || [];
    }, [
        rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.labels.nodes
    ]);
    const labels = useMemo(()=>{
        const appliedLabelsThatExists = !appliedLabels ? [] : appliedLabels.filter(isNotNull);
        return sortLabels(appliedLabelsThatExists);
    }, [
        appliedLabels
    ]);
    const selectedItems = useMemo(()=>[
            post
        ], [
        post
    ]);
    const alterLabelsForItems = useAlterLabelsForItems(labels, selectedItems);
    const focusWhen = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.focusWhen;
    const { disabled  } = usePostPage();
    const { state  } = usePostPageEditor();
    const showTodoListEditor = state.editor === "CREATE_TODOLIST";
    const todoLists = post.todoLists.nodes;
    const todos = post.todos.nodes;
    const { renderNote , setIsNoteBlank  } = usePostPageNoteEditor({
        note: !!note
    });
    const assignees = useMemo(()=>{
        return assignments.map(({ assignee  })=>assignee).filter(isNotNull);
    }, [
        assignments
    ]);
    const workspaceMembers = useMemo(()=>{
        var ref;
        return ((rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : (ref = rootTopicOrSelf.members) === null || ref === void 0 ? void 0 : ref.nodes) || []).map((topicMember)=>topicMember.user).filter(isNotNull);
    }, [
        rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : (ref1 = rootTopicOrSelf.members) === null || ref1 === void 0 ? void 0 : ref1.nodes
    ]);
    const { elements  } = usePostPageAssignAndLabelAction(post);
    const { elements: elements2  } = usePostPageSharedGlobalHandlers(post);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            elements,
            elements2,
            breadcrumbsList && rootOwner && /*#__PURE__*/ _jsx(PostPageHeader, {
                breadcrumbsList: breadcrumbsList,
                owner: rootOwner,
                previous: post.previous,
                next: post.next,
                appendMeta: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        currentUserHasStarred && /*#__PURE__*/ _jsx(PostPageHeaderStarredButton, {
                            item: post
                        }),
                        focusWhen && /*#__PURE__*/ _jsx(PostPageHeaderFocusWhenButton, {
                            postId: id,
                            focusWhen: focusWhen
                        }),
                        (when || whenReminder || deadline) && /*#__PURE__*/ _jsx(PostPageWhenOrDeadline, {
                            item: post
                        }),
                        appliedLabels && appliedLabels.length !== 0 && /*#__PURE__*/ _jsx(PostPageLabels, {
                            rootURL: rootURL,
                            labels: labels,
                            alterLabelsForItems: alterLabelsForItems
                        }),
                        assignees.length > 0 && /*#__PURE__*/ _jsx(PostPageAssignees, {
                            assignees: assignees
                        })
                    ]
                }),
                append: /*#__PURE__*/ _jsx(PostPagePost, {
                    post: post
                })
            }),
            /*#__PURE__*/ _jsx(PostPagePageBanner, {
                item: post,
                isRootTopicForPostType: (parentTopic === null || parentTopic === void 0 ? void 0 : parentTopic.isRootTopic) || false,
                negativeMargins: typeof url === "string" || renderNote || showTodoListEditor || todoLists.length > 0
            }),
            /*#__PURE__*/ _jsxs(RenderIfChildExists, {
                component: /*#__PURE__*/ _jsx(PostPageCardsWrapper, {}),
                children: [
                    (renderNote || typeof url === "string") && /*#__PURE__*/ _jsxs(PostPageEmbedNoteCard, {
                        children: [
                            typeof url === "string" && /*#__PURE__*/ _jsx(UrlDisplay, {
                                url: url,
                                title: linkTitle,
                                description: linkDescription,
                                websiteName: websiteName,
                                image: linkImage,
                                logo: linkLogo
                            }),
                            renderNote && /*#__PURE__*/ _jsx(PostPageNoteEditor, {
                                setIsNoteBlank: setIsNoteBlank,
                                itemId: id,
                                note: note
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(PostPageTodos, {
                        workspaceMembers: workspaceMembers,
                        todos: todos,
                        todoLists: todoLists,
                        postId: id,
                        postNodeId: nodeId,
                        disabled: disabled,
                        wrapperComponent: PostPageCard,
                        labels: allLabels,
                        rootTopicId: rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.id
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(PostPageComments, {
                item: post,
                commentCount: commentCount,
                comments: comments.nodes
            })
        ]
    });
};
export default PostPageViewsPostMain;
